import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import "../../style/myStyle.css"; // Importa il tuo file CSS
import { ReactNotifications } from "react-notifications-component";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import Background from "../../components/Background";

import { startToast, updateToastSuccess, updateToastError } from '../../utils/notification-loading';

import API from "../../api/index";

const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
  margin-top: 100px;
`;


const StyledText = styled(TextField)`
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #52a0a6; // Change to your desired focus color
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: #52a0a6; // Change to your desired label focus color
  }
`;

const ForgotPassword = ({ tipo }) => {
 
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    startToast();
    event.preventDefault();
    
    API.reqForgotPassword({ email: email, type: tipo }).then((response) => {
      updateToastSuccess("Code sent successfully, check your email");
    }).catch((error) => {
      
      updateToastError("Error on password reset");
    });
  };


  return (
    <>
    <Background />
    <div className="app-container">
      <ReactNotifications />
      <Container component="main" maxWidth="xs">
        <StyledCard>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "1e1e1e" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Forgot Password
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <StyledText
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#2d2d2d !important",
                    mt: 3,
                    mb: 2,
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                  style={{ fontWeight: "bold" }}
                >
                  Send
                </Button>
              </Box>
            </Box>
          </CardContent>
        </StyledCard>
      </Container>
    </div>
    </>
  );
};

export default ForgotPassword;
